import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

import moment from 'moment'

/* HOC Components */

import { select } from 'react-redux/actions/highlight'

/* Components */
import AssetPreview from '../asset/preview'

/* Widgets */
import DatetimeInput from 'widget/datetime-input'
import DurationInput from 'widget/duration-input'
import WeekdayInput from 'widget/weekday-input'
import TextInput from 'widget/text-input'
import Thumbnail from 'widget/thumbnail'
import { Highlight, MODE as HIGHLIGHT_MODE } from 'widget/highlight'
import InfoText from 'widget/info-text'
import {
  RemoveDialog,
  SCHEME as REMOVE_DIALOG_SCHEME
} from 'widget/remove-dialog'
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

/* Actions */
import { showModal, hideModal } from 'react-redux/actions/modal'
import {
  moveAsset,
  appendAssetAt,
  removeAsset,
  removeAndInsertAsset,
  saveAssetStartTime,
  saveAssetStopTime,
  saveAssetDuration,
  saveAssetSchedule
} from "react-redux/actions/playlist"
import { startDrag, stopDrag } from 'react-redux/actions/drag-and-drop'
import { fetchItem as fetchAssetItem } from 'react-redux/actions/asset'

/* Selectors */
import { getPlaylistAsset } from 'react-redux/selectors/playlist'
import { getDragAndDrop } from 'react-redux/selectors/drag-and-drop'

import { isVideoAsset } from 'util/file'

/* Styles */
import './asset.css'

/* Single Playlist Asset as part of Playlist Component */
class PlaylistAsset extends Component {

  constructor(props) {
    super(props)
    this.state = {
      removeCommit: false,
      isDropTarget: false,
      insertBefore: false,
      dragging: false
    }
    this.dragEnterCount = 0
  }

  componentDidMount() {
    const { fetchAssetItem, assetId, assets } = this.props
    fetchAssetItem(assetId)
  }

  /* Drag & Drop */
  onDragStart(e) {
    const {
      uid,
      assetId,
      index,
      startDrag
    } = this.props
    e.stopPropagation()
    if(this.durationInput && this.durationInput.inputElement)
      this.durationInput.inputElement.blur()
    if(this.startInput && this.startInput.inputElement)
      this.startInput.inputElement.blur()
    if(this.stopInput && this.stopInput.inputElement)
      this.stopInput.inputElement.blur()
    this.setState({ dragging:true })
    e.dataTransfer.setData(
      'text',
      JSON.stringify({ uid, domain:'playlistAsset', index })
    )
    startDrag('playlistAsset', uid, { index })
  }

  onDragEnd(e) {
    this.setState({ dragging: false })
    e.stopPropagation()
  }

  isDropTarget() {
    const { index, uid, dragAndDrop } = this.props
    return (
      dragAndDrop.domain === "asset"
      || dragAndDrop.domain === "playlistAsset"
    )
    && (
      dragAndDrop.uid !== uid
      || (dragAndDrop.opts && dragAndDrop.opts.index != index)
    )
  }

  onDragOver(e) {
      const { index, uid, dragAndDrop } = this.props
      e.preventDefault()
      e.stopPropagation()
      if (
        this.isDropTarget()
      ){
        this.setState({isDropTarget: true})
        let rect = this.measureElem.getClientRects()
        if(rect.length){
          const y = e.pageY - rect[0].top - rect[0].height/2
          const insertBefore = y < 0
          this.setState({ insertBefore })
        }
      }
  }

  onDragEnter(e) {
    const { index, uid, dragAndDrop } = this.props
    this.dragEnterCount++
    //e.preventDefault()
    e.stopPropagation()
    if (
      this.isDropTarget()
    ){
      this.setState({isDropTarget: true})
      let rect = this.measureElem.getClientRects()
      if(rect.length){
        const y = e.pageY - rect[0].top - rect[0].height/2
        const insertBefore = y < 0
        this.setState({ isDropTarget: true, insertBefore })
      }
    } else {
      this.setState({isDropTarget: false})
    }
  }

  onDragLeave(e) {
    const { index } = this.props
    e.preventDefault()
    e.stopPropagation()
    if(this.dragEnterCount) this.dragEnterCount--
    if (!this.dragEnterCount)
      this.setState({isDropTarget: false, insertBefore: false})
  }

  onDrop(e) {
    const {
      uid,
      index,
      appendAssetAt,
      moveAsset,
      removeAndInsertAsset
    } = this.props
    const { insertBefore } = this.state
    e.preventDefault()
    e.stopPropagation()
    if (!this.isDropTarget()) return
    try {
      const data = JSON.parse(e.dataTransfer.getData('text'))
      if(data.domain === "asset") {
         appendAssetAt(uid, data.uid, (insertBefore)?index:index+1)
      } else if (data.domain === "playlistAsset") {
        if (data.uid === uid) {
          moveAsset(uid, data.index, (insertBefore)?index:index+1)
        } else {
          removeAndInsertAsset(
            data.uid,
            data.index,
            uid,
            (insertBefore)?index:index+1
          )
        }
      }
    } catch (e) {
        return
    }
    this.dragEnterCount = 0
    this.setState({isDropTarget: false, insertBefore: false})
  }

  /* Helpers */
  getListItemClass() {
    const { selected, isAscendant, isDescendant } = this.props
    const { isDropTarget, insertBefore } = this.state
    var className = "playlist-asset component"
    if (selected) className += " highlight-selected"
    else if (isAscendant) className += " highlight-ascendant"
    else if (isDescendant) className += " highlight-descendant"
    if (isDropTarget) className += " drop-target"
    if (isDropTarget && insertBefore) className += " insert-before"
    else if (isDropTarget && !insertBefore) className += " insert-after"
    return className
  }


  onSaveStartTime(value) {
    const { uid, index, saveAssetStartTime } = this.props
    if (value && this.validateStartTime(value)) {
      saveAssetStartTime(
        uid,
        index,
        moment(value).utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
      )
    } else if (!value) {
      saveAssetStartTime(uid, index, null)
    }
  }

  onEditStartTime() {
    const { select, assetId } = this.props
    select("asset", assetId)
  }

  validateStartTime(value) {
    if (this.props && this.props.timeConstraint) {
      const { timeConstraint } = this.props
      const { stopTime } = timeConstraint
      if (value && stopTime) {
        if (moment(stopTime).isBefore(value)) return false
      }
    }
    return true
  }


  onSaveStopTime(value) {
    const { uid,  index, saveAssetStopTime } = this.props
    if (value && this.validateStopTime(value)) {
      saveAssetStopTime(
        uid,
        index,
        moment(value).utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
      )
    } else if (!value) {
      saveAssetStopTime(uid, index, null)
    }
  }

  onEditStopTime() {
    const { select, assetId } = this.props
    select("asset", assetId)
  }

  validateStopTime(value) {
    if (this.props && this.props.timeConstraint) {
      const { timeConstraint } = this.props
      const { startTime } = timeConstraint
      if (startTime && value) {
        if (moment(value).isBefore(startTime)) return false
      }
    }
    return true
  }


  onSaveDuration(value) {
    const { uid, index, saveAssetDuration } = this.props
    let duration = Math.round(parseFloat(value) * 1000)
    saveAssetDuration(uid, index, duration)
  }

  onEditDuration() {
    const { select, assetId } = this.props
    select("asset", assetId)
  }


  onSaveWeekday(value) {
    const { uid, index, saveAssetSchedule } = this.props
    //let duration = Math.round(parseFloat(value) * 1000)
    //console.log("onSaveWeekday", value)
    saveAssetSchedule(uid, index, {weekday:value})
  }

  onEditWeekday() {
    const { select, assetId } = this.props
    //select("asset", assetId)
  }

  validateDuration(value) {
    const { raw } = this.props
    if (raw && isVideoAsset(raw.mimeType)) return true
    var val = parseFloat(value)
    return _.isNumber(val) && val >= 0.001
  }

  onRemoveClick(e) {
    e.stopPropagation()
    this.setState({
      removeCommit: true
    })
  }

  onRemoveCommitClick(e) {
    const {
      uid,
      index,
      removeAsset
    } = this.props
    e.stopPropagation()
    removeAsset(uid, index)
    this.setState({
      removeCommit: false
    })
  }

  onRemoveCancelClick(e) {
    e.stopPropagation()
    this.setState({
      removeCommit: false
    })
  }

  onAssetPreview(e) {
    const { showModal, assetId, uid, select } = this.props
    e.stopPropagation() // prevent event from deselecting item
    select("asset", assetId)
    showModal(<AssetPreview uid={ assetId }/>)
  }

  onFocusPreview() {
    const { select, assetId } = this.props
    select("asset", assetId)
  }

  /* Rendering */

  renderRemoveButton() {
    const { t } = this.props
    return (
      <button
        className="remove"
        title={ t("playlist:asset.remove")}
        onClick={ this.onRemoveClick.bind(this) }
      >
        <Icon icon={ ICON.DELETE } size={ 24 } circle={ false } />
      </button>
    )
  }

  renderRemoveCommit() {
      const { t, name, fileName, assetId } = this.props
      const { removeCommit } = this.state
      if (!removeCommit) return null
      return (
        <RemoveDialog
          text={
            t(
              "playlist:asset.removeDialog.text",
              { name: name || fileName || assetId }
            )
          }
          scheme={ REMOVE_DIALOG_SCHEME.REMOVE }
          onCancel={ this.onRemoveCancelClick.bind(this) }
          cancelLabel={ t("playlist:asset.removeDialog.cancelButtonLabel") }
          onConfirm={ this.onRemoveCommitClick.bind(this) }
          confirmLabel={ t("playlist:asset.removeDialog.confirmButtonLabel") }
          />
      )
  }

  renderItemToolbar() {
    return (
      <div className="item-toolbar">
        { this.renderRemoveButton() }
      </div>
    )
  }

  renderStartInput() {
    const { t, timeConstraint } = this.props
    let value = null
    if(timeConstraint && timeConstraint.startTime){
      value = moment(timeConstraint.startTime).local().toDate()
    }
    return (
      <DatetimeInput
        label={ t('playlist:asset.startInput.label') }
        labelWidth={ 50 }
        placeholder={ t('playlist:asset.startInput.placeholder') }
        value={ value }
        ref={ (elem) => { this.startInput = elem }}
        onSave={ this.onSaveStartTime.bind(this) }
        onEdit={ this.onEditStartTime.bind(this) }
        validate={ this.validateStartTime.bind(this) }
        clearTitle={ t("input:clearTitle")}
        resetTitle={ t("input:resetTitle")}
        saveTitle={ t("input:saveTitle")}
      />
    )
  }

  renderStopInput() {
    const { t, timeConstraint } = this.props
    let value = null
    if(timeConstraint && timeConstraint.stopTime){
      value =  moment(timeConstraint.stopTime).local().toDate()
    }
    return (
      <DatetimeInput
        label={ t('playlist:asset.stopInput.label') }
        labelWidth={ 50 }
        placeholder={ t('playlist:asset.stopInput.placeholder') }
        value={ value }
        ref={ (elem) => { this.stopInput = elem }}
        onSave={ this.onSaveStopTime.bind(this) }
        onEdit={ this.onEditStopTime.bind(this) }
        validate={ this.validateStopTime.bind(this) }
        clearTitle={ t("input:clearTitle")}
        resetTitle={ t("input:resetTitle")}
        saveTitle={ t("input:saveTitle")}
      />
    )
  }

  renderDurationInput() {
    const {
      t,
      fileName,
      duration,
      assetDuration,
      raw,
    } = this.props
    const dur = duration || assetDuration
    // disabled={ /*isVideoAsset(raw.mimeType)*/ }
    return <DurationInput
      className="durationInput"
      label={ t('playlist:asset.durationInput.label') }
      labelWidth={ 50 }
      value={ (dur/1000) }
      ref={ (elem) => { this.durationInput = elem }}
      placeholder={ t('playlist:asset.durationInput.placeholder') }
      onSave={ this.onSaveDuration.bind(this) }
      onEdit={ this.onEditDuration.bind(this) }
      validate={ this.validateDuration.bind(this) }
      clearTitle={ t("input:clearTitle")}
      resetTitle={ t("input:resetTitle")}
      saveTitle={ t("input:saveTitle")}
    />
  }

  renderWeekdayInput() {
    const {
      t,
      fileName,
      raw,
      schedule,
      organizationSchedule
    } = this.props
    //console.log("renderWeekdayInput", schedule)
    if (!organizationSchedule) return
    const val = schedule && schedule.weekday || []
    //console.log(val)
    // disabled={ /*isVideoAsset(raw.mimeType)*/ }
    return <WeekdayInput
      className="weekday"
      label={ t('playlist:asset.weekdayInput.label') }
      labelWidth={ 50 }
      value={ val }
      ref={ (elem) => { this.weekdayInput = elem }}
      weekdayNames={[
        t('playlist:asset.weekdayInput.sunday'),
        t('playlist:asset.weekdayInput.monday'),
        t('playlist:asset.weekdayInput.tuesday'),
        t('playlist:asset.weekdayInput.wednesday'),
        t('playlist:asset.weekdayInput.thursday'),
        t('playlist:asset.weekdayInput.friday'),
        t('playlist:asset.weekdayInput.saturday')
      ]}
      placeholder={ t('playlist:asset.weekdayInput.placeholder') }
      onSave={ this.onSaveWeekday.bind(this) }
      clearTitle={ t("input:clearTitle")}
      resetTitle={ t("input:resetTitle")}
      saveTitle={ t("input:saveTitle")}
    />
  }
  getThumnailSrc() {
    const { thumbnail } =  this.props
    if (thumbnail) return thumbnail.url
  }


  isSelected() {
    const { domain, uid } = this.props.highlight.active
    return domain === "asset" && uid === this.props.assetId
  }

  isAscendant() {
    const { ascendants } = this.props.highlight
    return ascendants["asset"] && ascendants["asset"][this.props.assetId]

  }

  isDescendant() {
    const { descendants } = this.props.highlight
    return descendants["asset"] && descendants["asset"][this.props.assetId]
  }

  getHighlightMode() {
    if (this.isSelected()) return  HIGHLIGHT_MODE.SELECTED
    else if (this.isAscendant()) return  HIGHLIGHT_MODE.CHILD
    else if (this.isDescendant()) return  HIGHLIGHT_MODE.PARENT
  }

  render() {
    const {
      t,
      name,
      fileName,
      assetId,
      duration,
      toggleSelect,
      index,
      select
    } = this.props
    return (
      <li
        key={ index }
        className={ this.getListItemClass() }
        onDragLeave={ this.onDragLeave.bind(this) }
        onDragStart={ this.onDragStart.bind(this) }
        onDragOver={ this.onDragOver.bind(this) }
        onDrop={ this.onDrop.bind(this) }
        onDragEnter={ this.onDragEnter.bind(this) }
        draggable={ true }
        onClick={ (e)=>{ select("asset", assetId) } }
        ref={ (ref) => { this.measureElem = ref } }
      >
        <div className="border">
          <div className="detail">
            <Highlight mode={ this.getHighlightMode() } />
            <Thumbnail
              src={ this.getThumnailSrc() }
              title={ t("asset:item.preview") }
              onFocus={ this.onFocusPreview.bind(this) }
              onClick={ this.onAssetPreview.bind(this) }
            />
            <div className="label">
              <InfoText text={ name || fileName || assetId }/>
              { this.renderDurationInput() }
              <div className="time-constraint">
                { this.renderStartInput() }
                { this.renderStopInput() }
              </div>
              <div className="scheduling">
                { this.renderWeekdayInput() }
              </div>
            </div>
            { this.renderItemToolbar() }
            <div className="insert-before-indicator">
              <Icon
                icon={ ICON.CARET_UP }
                size={ 36 }
                circle={ false }
                scheme={ ICON_SCHEME.DRAGANDDROP }
                interactive={ false }
              />
            </div>
            <div className="insert-after-indicator">
              <Icon
                icon={ ICON.CARET_DOWN }
                size={ 36 }
                circle={ false }
                scheme={ ICON_SCHEME.DRAGANDDROP }
                interactive={ false }
               />
            </div>
          </div>
        </div>
        { this.renderRemoveCommit() }
      </li>
    )
  }
}

PlaylistAsset.propTypes = {
  uid: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
}

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      moveAsset,
      appendAssetAt,
      removeAsset,
      removeAndInsertAsset,
      saveAssetStartTime,
      saveAssetStopTime,
      saveAssetDuration,
      saveAssetSchedule,
      startDrag,
      stopDrag,
      select,
      showModal,
      fetchAssetItem
    },
    dispatch
  )
}

function mergeProps(stateProps, dispatchProps, ownProps){
  return Object.assign(
    {},
    dispatchProps,
    getPlaylistAsset(stateProps, ownProps.uid, ownProps.index),
    { dragAndDrop: getDragAndDrop(stateProps) },
    { highlight: stateProps.highlight },
    ownProps
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PlaylistAsset)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/playlist/asset.jsx